import { createFileRoute } from '@tanstack/react-router';
import { CobranzasPage } from '@/components/CobranzasPage';
import { ProductRouteGuard } from '@/components/ProductRouteGuard';

export const Route = createFileRoute('/_authenticated/cobranzas/')({
  component: CobranzasRoute,
});

function CobranzasRoute(): JSX.Element {
  return (
    <ProductRouteGuard
      products={['Empresa']}
      requirePermission="canViewInvoices"
      title="Cobranzas no disponible"
      description="Seleccioná un producto de facturación con permisos para ver comprobantes antes de abrir cobranzas."
    >
      <CobranzasPage />
    </ProductRouteGuard>
  );
}
